import Filter from 'bad-words';

const filter = new Filter();

export const containsProfanity = (text: string): boolean => {
  if (!text.trim()) return false;
  return filter.isProfane(text);
};

export const PROFANITY_ERROR_MESSAGE =
  'Your message contains inappropriate language. Please revise and try again.';
